/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DynamicMappingsInputMappedValue } from './DynamicMappingsInputMappedValue';
import {
    DynamicMappingsInputMappedValueFromJSON,
    DynamicMappingsInputMappedValueFromJSONTyped,
    DynamicMappingsInputMappedValueToJSON,
} from './DynamicMappingsInputMappedValue';

/**
 * 
 * @export
 * @interface DynamicMappingsInputEntry
 */
export interface DynamicMappingsInputEntry {
    /**
     * The name of the field in your application.
     * @type {string}
     * @memberof DynamicMappingsInputEntry
     */
    mapToName: string;
    /**
     * Optional display name of the field to show the user in the mapping UI.
     * @type {string}
     * @memberof DynamicMappingsInputEntry
     */
    mapToDisplayName?: string;
    /**
     * Optional prompt to show the user in the mapping UI.
     * @type {string}
     * @memberof DynamicMappingsInputEntry
     */
    prompt?: string;
    /**
     * If you would like the user to map a set of possible values, this is the list of possible values of the field in your application.
     * @type {Array<DynamicMappingsInputMappedValue>}
     * @memberof DynamicMappingsInputEntry
     */
    mappedValues?: Array<DynamicMappingsInputMappedValue>;
    /**
     * The name of the field in SaaS provider, if present, then we will not prompt the user to map the field.
     * @type {string}
     * @memberof DynamicMappingsInputEntry
     */
    fieldName?: string;
}

/**
 * Check if a given object implements the DynamicMappingsInputEntry interface.
 */
export function instanceOfDynamicMappingsInputEntry(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "mapToName" in value;

    return isInstance;
}

export function DynamicMappingsInputEntryFromJSON(json: any): DynamicMappingsInputEntry {
    return DynamicMappingsInputEntryFromJSONTyped(json, false);
}

export function DynamicMappingsInputEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): DynamicMappingsInputEntry {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'mapToName': json['mapToName'],
        'mapToDisplayName': !exists(json, 'mapToDisplayName') ? undefined : json['mapToDisplayName'],
        'prompt': !exists(json, 'prompt') ? undefined : json['prompt'],
        'mappedValues': !exists(json, 'mappedValues') ? undefined : ((json['mappedValues'] as Array<any>).map(DynamicMappingsInputMappedValueFromJSON)),
        'fieldName': !exists(json, 'fieldName') ? undefined : json['fieldName'],
    };
}

export function DynamicMappingsInputEntryToJSON(value?: DynamicMappingsInputEntry | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'mapToName': value.mapToName,
        'mapToDisplayName': value.mapToDisplayName,
        'prompt': value.prompt,
        'mappedValues': value.mappedValues === undefined ? undefined : ((value.mappedValues as Array<any>).map(DynamicMappingsInputMappedValueToJSON)),
        'fieldName': value.fieldName,
    };
}

